import * as React from "react";

import { cn } from "../../lib/utils";

export interface FloatingLabelTextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label: string;
}

const FloatingLabelTextarea = React.forwardRef<
  HTMLTextAreaElement,
  FloatingLabelTextareaProps
>(({ className, label, ...props }, ref) => {
  const id = React.useId();

  return (
    <div className="relative">
      <textarea
        id={id}
        className={cn(
          "peer min-h-[120px] rounded-md w-full border border-input bg-background px-3 py-6 text-sm ring-offset-background placeholder:text-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        onFocus={(e) => {
          props.onFocus?.(e);
        }}
        onBlur={(e) => {
          props.onBlur?.(e);
        }}
        onChange={(e) => {
          props.onChange?.(e);
        }}
        {...props}
      />
      <label
        htmlFor={id}
        className={cn(
          "pointer-events-none",
          "absolute -top-[10px] left-0.5 px-2 bg-background z-10 scale-90 transform text-sm text-primary transition-all duration-150",
          "peer-focus:-top-[10px] peer-focus:scale-90",
          "peer-placeholder-shown:top-4 peer-placeholder-shown:scale-100"
        )}
      >
        {label}
      </label>
    </div>
  );
});

FloatingLabelTextarea.displayName = "FloatingLabelTextarea";

export { FloatingLabelTextarea };
